// src/features/developer/components/ToolSection.tsx
import React, { ReactNode } from 'react';
import { Paper, Typography, Box, Divider } from '@mui/material';

interface ToolSectionProps {
    title: string;
    children: ReactNode;
}

const ToolSection: React.FC<ToolSectionProps> = ({ title, children }) => {
    return (
        <Paper
            variant="outlined"
            sx={{
                p: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
        >
            <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold' }}>
                {title}
            </Typography>
            <Divider />
            <Box sx={{ pt: 1 }}>
                {children}
            </Box>
        </Paper>
    );
};

export default ToolSection;